bq.global.percentageKnob = function() {
  $('[data-bq="percentage-knob"]').each(function(){
    var $this = $(this);
    var val = $this.data('value');
    if(val) {
      var calc = 180 / 100 * val;
      $this.html('<div><strong></strong></div><div><strong></strong></div><span><strong>'+val+'%</strong></span>');
      $this.find('div:first-child, div strong').css('transform', 'rotate('+calc+'deg)');
    }
  });
};

$(document).on('bq.updatePercentageKnob', bq.global.percentageKnob);

bq.init.push(bq.global.percentageKnob);
